import phemeCard from '../assets/Portfolio/pheme-logo.svg';

export const BLOG_POSTS = [
  {
    id: 1,
    title: 'PHEME Is Live — Here\'s What It Does and Where to Find It',
    excerpt: 'PHEME is a live market-intelligence server that reads regime, sentiment, and macro — a single actionable signal, callable by any agent across five surfaces.',
    date: '2026-07-15',
    url: 'https://blog.quanturama.com/post/pheme-is-live-here-s-what-it-does-and-where-to-find-it',
    image: phemeCard,
    category: 'Products',
    tags: ['PHEME', 'Market Intelligence', 'AI Agents', 'MCP']
  },
  {
    id: 2,
    title: 'How AI Agents Read the Crypto Market Using PHEME',
    excerpt: 'Price tells you where the market is, not what it is doing. PHEME gives an agent the regime, sentiment, and macro read it needs before it acts — one MCP call.',
    date: '2026-07-15',
    url: 'https://blog.quanturama.com/post/how-ai-agents-read-the-crypto-market-using-pheme',
    image: phemeCard,
    category: 'Products',
    tags: ['PHEME', 'AI Agents', 'MCP', 'Trading']
  },
  {
    id: 3,
    title: 'Momentum Scores Tell You Speed. PHEME Tells You What Terrain You\'re On.',
    excerpt: 'Momentum measures how fast price moves. PHEME classifies the regime that decides what that movement means — the context a strategy needs before it commits.',
    date: '2026-07-15',
    url: 'https://blog.quanturama.com/post/momentum-scores-tell-you-speed-pheme-tells-you-what-terrain-you-re-on',
    image: phemeCard,
    category: 'Products',
    tags: ['PHEME', 'Regime', 'Algo Trading', 'CMC']
  }
];

export const BLOG_CONFIG = {
  mainBlogUrl: 'https://blog.quanturama.com',
  postsPerPage: 3
};
